import React, { useState, useEffect } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import achalLogo from "../assets/images/achal_logo.png";
import { 
  FiUser, FiLock, FiMail, FiPhone, FiBriefcase, 
  FiMapPin, FiKey, FiCheckCircle, FiShield, FiCalendar, 
  FiHash, FiClock, FiInfo, FiHelpCircle, FiChevronRight, FiGlobe, FiX
} from "react-icons/fi";

const Settings = () => {
  const [profile, setProfile] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [showAbout, setShowAbout] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await API.get("/hod/profile");
      if (res.data.success) setProfile(res.data.data);
    } catch (err) {
      console.error("Error loading profile", err);
    }
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (!newPassword || newPassword.length < 6) return alert("Password too short!");
    setBtnLoading(true);
    try {
      const res = await API.put("/hod/change-password", { newPassword });
      if (res.data.success) {
        alert("Security Credentials Updated!");
        setNewPassword("");
      }
    } catch (err) { alert("Failed to update password"); }
    finally { setBtnLoading(false); }
  };

  //  Gmail Direct Handler (Opens Gmail in new tab with Compose)
  const handleSupportClick = () => {
    const email = "admin@achaljewels.com";
    const subject = encodeURIComponent("HOD Support Request - " + profile?.full_name);
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}`;
    window.open(gmailUrl, "_blank");
  };

  if (!profile) return <div style={styles.loader}> Loading Secure Environment...</div>;

  const profileImg = profile.profile_image 
    ? `https://api.ajplservices.tech/uploads/profile/${profile.profile_image}` 
    : null;

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>
        
        {/* --- TOP HEADER --- */}
        <div style={styles.header}>
          <div style={styles.headerTitle}>
            <h2 style={styles.mainTitle}>Account Settings</h2>
            <div style={styles.breadcrumb}>Dashboard / Settings / Profile</div>
          </div>
          <div style={styles.idBadge}>
            <span style={styles.idLabel}>USER ID</span>
            <span style={styles.idValue}>{profile.id}</span>
          </div>
        </div>

        <div style={styles.flexGrid}>
          
          {/* --- LEFT: PROFILE CARD --- */}
          <div style={styles.leftCol}>
            <div style={styles.profileCard}>
              <div style={styles.profileHero}>
                <div style={styles.avatarWrapper}>
                  {profileImg ? (
                    <img 
                      src={profileImg} 
                      alt="Profile" 
                      style={styles.avatarImg} 
                      onError={(e) => { e.target.src = "https://via.placeholder.com/150?text=Achal"; }}
                    />
                  ) : (
                    <div style={styles.avatarInitials}>{profile.full_name?.charAt(0) || "A"}</div>
                  )}
                </div>
                <h3 style={styles.fullName}>{profile.full_name}</h3>
                <p style={styles.usernameText}>@{profile.username}</p>
                <div style={styles.verifiedTag}>
                  <FiCheckCircle size={12} /> Verified {profile.role}
                </div>
              </div>

              <div style={styles.infoSection}>
                <label style={styles.sectionHeading}>PERSONAL INFORMATION</label>
                <InfoItem icon={<FiMail />} label="Official Email" value={profile.email} />
                <InfoItem icon={<FiPhone />} label="Phone Number" value={profile.phone} />
                
                <label style={styles.sectionHeading}>WORK & DESIGNATION</label>
                <InfoItem icon={<FiBriefcase />} label="Department" value={profile.department} />
                <InfoItem icon={<FiShield />} label="Designation" value={profile.designation} />
                <InfoItem icon={<FiMapPin />} label="Work Station" value={`Floor ${profile.floor_number}, Cabin ${profile.cabin_number}`} />
                <InfoItem icon={<FiClock />} label="Created On" value={new Date(profile.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} />
              </div>
            </div>
          </div>

          {/* --- RIGHT: SECURITY & SUPPORT --- */}
          <div style={styles.rightCol}>
            
            {/*  PASSWORD CARD */}
            <div style={styles.securityCard}>
              <div style={styles.securityHeader}>
                <FiLock style={styles.securityIcon} />
                <div>
                  <h4 style={styles.secTitle}>Change Password</h4>
                  <p style={styles.secSub}>Update your account security.</p>
                </div>
              </div>

              <form onSubmit={handlePasswordUpdate} style={styles.form}>
                <div style={styles.inputGroup}>
                  <label style={styles.inputLabel}>New Password</label>
                  <div style={styles.inputWrapper}>
                    <FiKey style={styles.fieldIcon} />
                    <input 
                      type="password" 
                      placeholder="6+ characters"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      style={styles.inputField}
                    />
                  </div>
                </div>
                <button type="submit" style={styles.submitBtn} disabled={btnLoading}>
                  {btnLoading ? "Processing..." : "Update Security Password"}
                </button>
              </form>
            </div>

            {/* 🛠️ SUPPORT & ABOUT CARD */}
            <div style={{ ...styles.securityCard, marginTop: '30px' }}>
              <div style={styles.sectionHeading}>HELP & SYSTEM INFO</div>
              
              <div style={styles.supportRow} onClick={handleSupportClick}>
                 <div style={styles.supportIcon}><FiHelpCircle /></div>
                 <div style={{ flex: 1 }}>
                    <div style={styles.supportTitle}>Help & Support</div>
                    <div style={styles.supportSub}>Mail to Admin via Gmail</div>
                 </div>
                 <FiChevronRight color="#CBD5E1" />
              </div>

<div style={styles.supportRow} onClick={() => window.location.href = "/about"}>
   <div style={{ ...styles.supportIcon, background: '#F0F9FF', color: '#0EA5E9' }}><FiInfo /></div>
   <div style={{ flex: 1 }}>
      <div style={styles.supportTitle}>About Achal Support</div>
      <div style={styles.supportSub}>System Workflow & Mobile App</div>
   </div>
   <FiChevronRight color="#CBD5E1" />
</div>
            </div>

          </div>
        </div>

        {/* --- 🏛️ ABOUT MODAL (Light Theme) --- */}
        {showAbout && (
          <div style={styles.modalOverlay}>
             <div style={styles.modalContent}>
                <button style={styles.closeBtn} onClick={() => setShowAbout(false)}><FiX /></button>
                <div style={{ textAlign: 'center', padding: '10px' }}>
                   <img src={achalLogo} alt="Achal" style={{ height: '70px', marginBottom: '15px' }} />
                   <h2 style={{ margin: 0, color: '#1E293B', fontSize: '24px', fontWeight: '800' }}>Achal Jewels Support</h2>
                   <p style={{ color: '#D4AF37', fontSize: '13px', fontWeight: '700', marginTop: '5px' }}>Version 1.0.0</p>
                   
                   <div style={styles.modalDivider}></div>
                   
                   <p style={styles.aboutDesc}>
                      Achal Jewels Support App is an enterprise-grade solution designed to manage internal logistics, maintenance, and technical ticket tracking. Our vision is to provide a seamless digital bridge between employees and the management for a faster resolution of workplace issues.
                   </p>
                </div>
             </div>
          </div>
        )}

      </div>
    </div>
  );
};

// --- Sub-Component for Info Rows ---
const InfoItem = ({ icon, label, value }) => (
  <div style={styles.infoItem}>
    <div style={styles.iconCircle}>{icon}</div>
    <div style={styles.infoContent}>
      <span style={styles.infoLabel}>{label}</span>
      <span style={styles.infoValue}>{value || "---"}</span>
    </div>
  </div>
);

const styles = {
  layout: { display: "flex", background: "#F4F7FE", minHeight: "100vh" },
  mainContent: { marginLeft: "260px", padding: "40px", flex: 1, fontFamily: "'Inter', sans-serif" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "35px" },
  mainTitle: { margin: 0, fontSize: "28px", fontWeight: "800", color: "#1E293B" },
  breadcrumb: { color: "#94A3B8", fontSize: "12px", marginTop: "5px", fontWeight: "600" },
  idBadge: { background: "#FFF", border: "1px solid #E2E8F0", padding: "8px 15px", borderRadius: "12px", textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.03)" },
  idLabel: { display: "block", fontSize: "9px", color: "#94A3B8", fontWeight: "800" },
  idValue: { fontSize: "14px", color: "#D4AF37", fontWeight: "800" },
  flexGrid: { display: "flex", gap: "30px", alignItems: "flex-start" },
  leftCol: { flex: "1.3" },
  rightCol: { flex: "1" },
  profileCard: { background: "#FFF", borderRadius: "30px", padding: "40px", border: "1px solid #F1F5F9", boxShadow: "0 10px 40px rgba(0,0,0,0.03)" },
  profileHero: { textAlign: "center", borderBottom: "1px solid #F8FAFC", paddingBottom: "30px", marginBottom: "30px" },
  avatarWrapper: { position: "relative", display: "inline-block", marginBottom: "20px" },
  avatarImg: { width: "130px", height: "130px", borderRadius: "45px", objectFit: "cover", border: "4px solid #D4AF37" },
  avatarInitials: { width: "130px", height: "130px", borderRadius: "45px", background: "#D4AF3715", color: "#D4AF37", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "45px", fontWeight: "800" },
  fullName: { margin: "0", fontSize: "24px", fontWeight: "800", color: "#1E293B" },
  usernameText: { color: "#94A3B8", fontSize: "14px", margin: "5px 0 15px 0", fontWeight: "500" },
  verifiedTag: { display: "inline-flex", alignItems: "center", gap: "6px", background: "#ECFDF5", color: "#10B981", padding: "6px 15px", borderRadius: "20px", fontSize: "11px", fontWeight: "800", textTransform: "uppercase" },
  sectionHeading: { display: "block", fontSize: "11px", color: "#D4AF37", fontWeight: "800", letterSpacing: "1.5px", margin: "25px 0 20px 0" },
  infoItem: { display: "flex", alignItems: "center", gap: "20px", marginBottom: "20px" },
  iconCircle: { width: "45px", height: "45px", background: "#F8FAFC", borderRadius: "15px", display: "flex", alignItems: "center", justifyContent: "center", color: "#94A3B8" },
  infoContent: { display: "flex", flexDirection: "column" },
  infoLabel: { fontSize: "10px", fontWeight: "700", color: "#94A3B8", textTransform: "uppercase", marginBottom: "2px" },
  infoValue: { fontSize: "15px", fontWeight: "600", color: "#1E293B" },
  securityCard: { background: "#FFF", borderRadius: "30px", padding: "30px", border: "1px solid #F1F5F9", boxShadow: "0 10px 40px rgba(0,0,0,0.03)" },
  securityHeader: { display: "flex", gap: "15px", alignItems: "center", marginBottom: "35px" },
  securityIcon: { fontSize: "22px", color: "#1E293B", background: "#F1F5F9", padding: "12px", borderRadius: "15px" },
  secTitle: { margin: "0", fontSize: "18px", fontWeight: "800", color: "#1E293B" },
  secSub: { margin: "5px 0 0 0", color: "#94A3B8", fontSize: "13px" },
  inputGroup: { marginBottom: "20px" },
  inputLabel: { display: "block", fontSize: "12px", fontWeight: "700", color: "#475569", marginBottom: "8px" },
  inputWrapper: { position: "relative" },
  fieldIcon: { position: "absolute", left: "15px", top: "50%", transform: "translateY(-50%)", color: "#94A3B8" },
  inputField: { width: "100%", padding: "14px 15px 14px 42px", borderRadius: "14px", border: "1px solid #E2E8F0", outline: "none", fontSize: "14px", boxSizing: "border-box" },
  submitBtn: { width: "100%", background: "#1E293B", color: "#FFF", border: "none", padding: "16px", borderRadius: "14px", fontSize: "14px", fontWeight: "700", cursor: "pointer" },

  supportRow: { display: 'flex', alignItems: 'center', gap: '15px', padding: '15px', background: '#F8FAFC', borderRadius: '18px', cursor: 'pointer', marginBottom: '12px', transition: '0.3s', border: '1px solid transparent' },
  supportIcon: { background: '#FFF7ED', color: '#F97316', width: '42px', height: '42px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', fontSize: '18px' },
  supportTitle: { color: '#1E293B', fontWeight: '700', fontSize: '14px' },
  supportSub: { color: '#94A3B8', fontSize: '11px' },

  // --- 🏛️ MODAL UI (Updated to Light Theme) ---
  modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(30, 41, 59, 0.7)', backdropFilter: 'blur(5px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalContent: { background: '#FFFFFF', width: '450px', borderRadius: '35px', padding: '40px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', border: '1px solid #F1F5F9', position: 'relative' },
  closeBtn: { position: 'absolute', top: '25px', right: '25px', background: '#F8FAFC', border: 'none', color: '#64748B', cursor: 'pointer', fontSize: '20px', borderRadius: '50%', width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  modalDivider: { width: '60px', height: '3px', background: '#D4AF37', margin: '20px auto', borderRadius: '10px' },
  aboutDesc: { color: '#475569', fontSize: '15px', lineHeight: '1.6', textAlign: 'center', fontWeight: '500' },
  devDesc: { color: '#64748B', fontSize: '13px', lineHeight: '1.6', textAlign: 'center' },
  webLink: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', color: '#1E293B', textDecoration: 'none', marginTop: '25px', fontSize: '14px', fontWeight: '800', border: '1px solid #E2E8F0', padding: '12px', borderRadius: '12px', background: '#F8FAFC' },

  loader: { height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", color: "#D4AF37", fontSize: "18px", fontWeight: "700" }
};

export default Settings;